var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { lazy } from 'react';
import { ROUTE_ROLES } from 'constants/app.constant';
import { SPARK_PATHS, SPARK_SUMMARY_PATHS } from '../constants/spark.constant';
import SparkRouteGuard from './SparkRouteGuard';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
var withSparkGuard = function (importFn) {
    var LazyComponent = lazy(importFn);
    var WrappedComponent = function (props) { return (<SparkRouteGuard>
      <LazyComponent {...props}/>
    </SparkRouteGuard>); };
    WrappedComponent.displayName = 'SparkGuardedComponent';
    return WrappedComponent;
};
var SparkSummaryPage = withSparkGuard(function () { return import(/* webpackChunkName: "SparkSummaryPage" */ 'reports/cw/components/pages/spark-summary/SparkSummaryPage'); });
var summaryRoutes = SPARK_SUMMARY_PATHS.map(function (path) { return ({
    path: path,
    exact: true,
    component: SparkSummaryPage,
    isPrivate: true,
    roles: INSTRUCTOR
}); });
export var SparkRoutes = {
    getRoutes: function () { return __spreadArray(__spreadArray([], summaryRoutes, true), [
        {
            path: SPARK_PATHS.students,
            exact: true,
            component: withSparkGuard(function () { return import(/* webpackChunkName: "SparkStudentsPage" */ 'reports/cw/components/pages/spark-students/SparkStudentsPage'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SPARK_PATHS.topics,
            exact: true,
            component: withSparkGuard(function () { return import(/* webpackChunkName: "SparkTopicsPage" */ 'reports/cw/components/pages/spark-topics/SparkTopicsPage'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SPARK_PATHS.assignments,
            exact: true,
            component: withSparkGuard(function () { return import(/* webpackChunkName: "SparkAssignmentsPage" */ 'reports/cw/components/pages/spark-assignments/SparkAssignmentsPage'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SPARK_PATHS.studentReport,
            exact: true,
            component: withSparkGuard(function () { return import(/* webpackChunkName: "SparkStudentReportPage" */ 'reports/cw/components/pages/spark-student-report/SparkStudentReportPage'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ], false); }
};
